<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pr_code,pr_detail,pr_orispeccode"
      placeholder="输入产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div class="weui-cell weui-cell_access" v-for="item in items" :key="item.pr_code">
        <div class="weui-cell__bd">
          <p>{{item.pr_code}} {{item.pr_detail}}</p>
          <p class="list-item-muted" v-if="item.pr_orispeccode">{{item.pr_orispeccode}}</p>
          <p class="list-item-muted" v-if="item.pr_spec">{{item.pr_spec}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ma_vendname}}</p>
          <p>
            <span v-format="'#,##0.#'">{{item.qty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <span class="list-item-status" v-if="item.pr_brand">{{item.pr_brand}}</span>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}张</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/report/osMakeInProcess",
      filters: [
        {
          type: "date",
          name: "make.createTime"
        }
      ]
    };
  }
};
</script>